import { Pressable, StyleSheet } from 'react-native'

import { FiatBackIcon } from '../icons/FiatBackIcon'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { useTheme } from '../theme/restyle'
import { KYC_FORM_METRICS } from './kycFormTheme'

/**
 * The disc every fiat step leaves the current screen by (1844:17447).
 *
 * It pays no status-bar inset of its own — the screen that draws it does, via
 * `useFlowStepFrame`. Insetting here too dropped it a full bar past the 5 the
 * frames leave it: 79 below the Dynamic Island where the design says 16.
 */
export function FiatBackButton({ onPress }: { onPress: () => void }) {
  const { t } = useFunkitTranslation()
  const theme = useTheme()

  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={t('common.back')}
      style={[
        styles.disc,
        { marginTop: KYC_FORM_METRICS.backButtonTop },
        { backgroundColor: theme.content.elements.ghosted },
      ]}
    >
      <FiatBackIcon color={theme.content.elements.primary} />
    </Pressable>
  )
}

const styles = StyleSheet.create({
  disc: {
    marginLeft: 16,
    width: KYC_FORM_METRICS.backButtonSize,
    height: KYC_FORM_METRICS.backButtonSize,
    borderRadius: KYC_FORM_METRICS.backButtonSize / 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
})
